small,
.small, input.small {
  font-size: 0.8em;
}

.large {
  font-size: large;
}

.smaller {
  font-size: smaller;
}

.footnote {
  opacity: 0.6;
}

.wrap {
  white-space: wrap;
}

.bold {
  font-weight: 600;
}

.error {
  color: var(--danger-color);
}

.muted {
  opacity: 0.6;
  &:hover {
    opacity: 0.75;
  }
}

.underline {
  text-decoration: underline;
}

.breadcrumb {
  position: fixed;
  left: calc(1rem - 0.4em);
  display: inline-flex;
  /*align-items: center;*/
  width: fit-content;
  /*align-items: center;*/
  gap: 0.35em;
  /*position: sticky;*/
  transform: translateY(0.5em);
  padding: 0.2em 0.4em;
  /*height: 32px;*/
  /*margin: -0.4em -0.6em;*/
  /*top: -0.4em;*/
  border-radius: 100px;
  z-index:1000;
  backdrop-filter: blur(10px);
}

.text-center {
  text-align: center;
}
